export default __webpack_public_path__ + "static/B07-148cca733adacc993a23a9f2e1123a0f.png";